import { Box, Button, Card, CardContent, Grid2, Typography } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom-v5-compat'

import TabHeader from '@/app/component/atom/tab-header'
import CanceledPlanWarning from '@/app/module/dashboard/component/canceled-plan-warning'
import { useGetPlan } from '@/app/module/plans/hooks/use-get-plan'
import { OrgPlan } from '@/app/module/plans/types'
import { selectActiveOrg } from '@/app/module/user/store/selectors'
import { useShowCanceled } from '@/app/module/user/store/ts/hooks'
import { Organization } from '@/app/types'

import ActiveSubscription from './active-subscription'

type Props = {}

const Subscription: React.FC<Props> = () => {
  const { data: activePlan } = useGetPlan()
  const activeOrg = useSelector(selectActiveOrg) as Organization | undefined
  const showCanceledWarning = useShowCanceled()
  const navigate = useNavigate()

  const toPlans = () => {
    navigate('/plans')
  }

  const noPlan = !activePlan
  const isTrial = activePlan && !activePlan.planId
  const trialEnded = activePlan && typeof activePlan.trialDaysLeft === 'number' && activePlan.trialDaysLeft <= 0
  const isOwner = activeOrg?.role === 'owner'

  return (
    <Card>
      <TabHeader title="Subscription Plan" />
      {showCanceledWarning && activePlan?.end && (
        <Box ml={1} mr={1}>
          <CanceledPlanWarning end={activePlan.end} />
        </Box>
      )}
      <CardContent>
        {!!activeOrg && (
          <Grid2 container>
            <Grid2 size={{ xs: 12, sm: 8 }}>
              {noPlan && (
                <Typography variant="h6" gutterBottom>
                  You are currently not on a plan
                </Typography>
              )}
              {isTrial && !trialEnded && (
                <Typography variant="h6" gutterBottom>
                  You have {activePlan.trialDaysLeft} days left on the Trial plan
                </Typography>
              )}
              {isTrial && trialEnded && (
                <Typography variant="h6" gutterBottom>
                  Your trial has ended
                </Typography>
              )}
              {isOwner && (noPlan || isTrial) && (
                <Button color="primary" size="small" variant="contained" onClick={toPlans}>
                  Select a plan
                </Button>
              )}
              {!isTrial && !!activePlan && <ActiveSubscription activePlan={activePlan as OrgPlan} isOwner={isOwner} />}
            </Grid2>
          </Grid2>
        )}
      </CardContent>
    </Card>
  )
}

export default Subscription
